var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-waiting-list-component" }, [
    _c(
      "ul",
      { staticClass: "room-waiting-list" },
      _vm._l(_vm.waitingList, function (user, i) {
        return _c("li", { key: i, staticClass: "room-waiting-item" }, [
          _c("div", { staticClass: "room-waiting-item-form" }, [
            _c("p", { staticClass: "room-waiting-item-title" }, [
              _vm._v(_vm._s(_vm.$t("common.number"))),
            ]),
            _c("p", { staticClass: "room-waiting-item-value" }, [
              _vm._v(_vm._s(i + 1)),
            ]),
          ]),
          _c("div", { staticClass: "room-waiting-item-form" }, [
            _c("p", { staticClass: "room-waiting-item-title" }, [
              _vm._v(_vm._s(_vm.$t("common.name"))),
            ]),
            _c("p", { staticClass: "room-waiting-item-value" }, [
              _vm._v(_vm._s(user.nickName || user.username)),
            ]),
          ]),
          _c("div", { staticClass: "room-waiting-item-form" }, [
            _c("p", { staticClass: "room-waiting-item-title" }, [
              _vm._v(_vm._s(_vm.$t("waitingRoom.join.time"))),
            ]),
            _c("p", { staticClass: "room-waiting-item-value" }, [
              _vm._v(_vm._s(_vm.getDateForm(user.joinDate))),
            ]),
          ]),
          _c("div", { staticClass: "room-waiting-item-form" }, [
            _c("p", { staticClass: "room-waiting-item-title" }, [
              _vm._v(_vm._s(_vm.$t("common.device.camera"))),
            ]),
            _c(
              "p",
              {
                staticClass: "room-waiting-item-value",
                class: [user.cameraStatus === "on" ? "success" : "error"],
              },
              [_vm._v(_vm._s(_vm.deviceStatus(user.cameraStatus)))]
            ),
          ]),
          _c("div", { staticClass: "room-waiting-item-form" }, [
            _c("p", { staticClass: "room-waiting-item-title" }, [
              _vm._v(_vm._s(_vm.$t("common.device.mic"))),
            ]),
            _c(
              "p",
              {
                staticClass: "room-waiting-item-value",
                class: [user.micStatus === "on" ? "success" : "error"],
              },
              [_vm._v(_vm._s(_vm.deviceStatus(user.micStatus)))]
            ),
          ]),
          _c("div", { staticClass: "room-waiting-item-form" }, [
            _c("p", { staticClass: "room-waiting-item-title" }, [
              _vm._v(_vm._s(_vm.$t("setting.join.role.title"))),
            ]),
            _c(
              "div",
              { staticClass: "room-waiting-item-value" },
              [
                _c("GrmSelect", {
                  attrs: {
                    fullWidth: "",
                    white: "",
                    options: _vm.userRoleOptions,
                  },
                  on: { input: (roleId) => _vm.changeUserRole(user, roleId) },
                }),
              ],
              1
            ),
          ]),
          _c("div", { staticClass: "room-waiting-item-form" }, [
            _c("p", { staticClass: "room-waiting-item-title" }, [
              _vm._v(_vm._s(_vm.$t("deviceSetting.preview.join.request"))),
            ]),
            _c(
              "div",
              { staticClass: "room-waiting-item-value" },
              [
                _c(
                  "VButton",
                  {
                    staticClass: "room-waiting-item-btn",
                    attrs: { small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.approveApi({
                          roomId: _vm.room.roomId,
                          userId: user.userId,
                          roleId: user.joinRoleId,
                        })
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.apply")))]
                ),
                _c(
                  "VButton",
                  {
                    staticClass: "room-waiting-item-btn",
                    attrs: { small: "", cancel: "" },
                    on: {
                      click: function ($event) {
                        return _vm.disapproveApi({
                          roomId: _vm.room.roomId,
                          userId: user.userId,
                          roleId: user.joinRoleId,
                        })
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.reject")))]
                ),
              ],
              1
            ),
          ]),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }